// extracted by mini-css-extract-plugin
export default {"cookie_button":"cookieButton_cookie_button__FK2Ts","sidebar":"cookieButton_sidebar__daaK2","selected":"cookieButton_selected__85HH1"};